import update from 'immutability-helper'
import { SIGN_IN, SIGN_UP, SIGN_OUT } from 'actions/auth'
import { UPDATE_USER } from 'actions/users'
import { UPDATE_USER_SESSION, CLEAR_USER_SESSION } from 'actions/userSession'

const setUserSession = (state, action) => {
  const { payload: { headers: { uid, client, "access-token": accessToken } } } = action
  return update(state, { $set: { uid, accessToken, client } })
}

const updateUserSession = (state, { updateHash }) => ({ ...state, ...updateHash })

const clearUserSession = state => null

const handlers = {
  [`${SIGN_IN}_FULFILLED`]: setUserSession,
  [`${SIGN_UP}_FULFILLED`]: setUserSession,
  [`${SIGN_OUT}_FULFILLED`]: clearUserSession,
  [`${UPDATE_USER}_FULFILLED`]: setUserSession,
  [UPDATE_USER_SESSION]: updateUserSession,
  [CLEAR_USER_SESSION]: clearUserSession
}

export default function userSessionReducer(state = null, action) {
  const handler = handlers[action.type]
  return handler ? handler(state, action) : state
}
